<template>
    <div>

        <h3>Done?</h3>
        <p>Great work! You may want to consider:</p>
        <LinkBox>
            <li><router-link to="/verify">Goto: Verify Your API</router-link> <span class="comment pulsate">// &lt;--- really cool!!!</span></li>
            <li><router-link to="/backend-java-deploy">Goto: Deploy Backend to the Cloud</router-link></li>
        </LinkBox>

        <h3>Navigation</h3>
        <p>Want to go somewhere? Here are some <i>&lt;a&gt;</i>-tags for you:</p>
        <LinkBox>
            <li><router-link to="/backend">Return: Backend Mission</router-link></li>
            <li><router-link to="/api">Goto: API Specification</router-link></li>
        </LinkBox>
    </div>
</template>

<script>

import LinkBox from '@/components/LinkBox.vue'

export default {
    name: 'BackendNav',
    components: {
      LinkBox
    }
}
</script>


<style scoped>
.pulsate {
  animation: pulsate 1s linear infinite;
}

@keyframes pulsate {
  50% {
    opacity: 0.1;
  }
}
</style>